// Journey lifecycle as the UI presents it. The server owns the rules (which
// transition is allowed, and for whom — see the journey's `allowed_actions`);
// this file only names and colours the statuses the API returns.

export const JOURNEY_STATUS_LABELS = Object.freeze({
  DRAFT: "Draft",
  PLANNED: "Planned",
  APPROVED: "Approved",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
});

// The lifecycle stages in order (the dashboard pipeline). `key` is the lowercased status.
export const JOURNEY_STATUS_STAGES = Object.freeze([
  { key: "draft", label: "Draft", color: "#9AA3B2" },
  { key: "planned", label: "Planned", color: "#3D9BD0" },
  { key: "approved", label: "Approved", color: "#2FA96A" },
  { key: "in_progress", label: "In Progress", color: "#F3B01B" },
  { key: "completed", label: "Completed", color: "#2FA96A" },
  { key: "cancelled", label: "Cancelled", color: "#9F1D21" },
]);

export const JOURNEY_STATUS_PILL = Object.freeze({
  DRAFT: "tsp-status-pill-muted",
  PLANNED: "tsp-status-pill-muted",
  APPROVED: "tsp-status-pill-success",
  IN_PROGRESS: "tsp-status-pill-progress",
  COMPLETED: "tsp-status-pill-success",
  CANCELLED: "tsp-status-pill-danger",
});

// The list screen's status filter -> the `status` query the API takes.
export const LIST_STATUS_FILTERS = Object.freeze({
  active: { label: "Active Journeys", query: "DRAFT,PLANNED,APPROVED,IN_PROGRESS" },
  completed: { label: "Completed Journeys", query: "COMPLETED" },
  cancelled: { label: "Cancelled Journeys", query: "CANCELLED" },
  all: { label: "All Journeys", query: undefined },
});

// Workflow actions as buttons (cancelling is the only one: a journey completes by
// itself once every stop is visited): label, look and confirmation text. Whether a
// button is SHOWN comes from the server (`allowed_actions`); this is only wording.
export const WORKFLOW_ACTION_UI = Object.freeze({
  cancel: { label: "Cancel Journey", tone: "outline-danger", done: "Journey cancelled." },
});

// Route-city execution state (API `visit_state`) -> the timeline / route badges.
export const VISIT_STATE_TO_CITY_STATUS = Object.freeze({ visited: "completed", current: "live", not_visited: "not_visited" });
export const VISIT_STATE_TO_ROUTE_STATUS = Object.freeze({ visited: "completed", current: "live", not_visited: "pending" });
